import {
  RESET_PRODUCT_REQUESTS_VIEW,
  FETCH_PRODUCT_REQUESTS_VIEW,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const requestProductViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_REQUESTS_VIEW:
      return { data: action.payload };
    case RESET_PRODUCT_REQUESTS_VIEW:
      return initialState;
    default:
      return state;
  }
};

export default requestProductViewReducer;
